export default {
  sidebar: {
    dropdown: {
      title: 'Sozlamalar',
      logout: 'Hisobdan chiqish',
      lang: 'Til',
      ru: 'Ruscha',
      uz: 'O‘zbekcha',
      toggleLabel: 'Qorong‘i rejim',
    },
  },
};
